import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Typography } from 'packages/common-frontend/components/Typography';
import { RadioCardGroup } from '~/core/routes/settings/implementations/common/Inputs';

export type CommitmentFormData = {
  isSublimit: 'yes' | 'no';
};

type AddCommitmentModalProps = {
  disclosure: UseDisclosureReturn;
  onAddCommitment: (commitment: CommitmentFormData) => void;
};

export const AddCommitmentModal = ({
  disclosure,
  onAddCommitment,
}: AddCommitmentModalProps) => {
  const form = useForm<CommitmentFormData>({});
  const { isOpen, onClose } = disclosure;

  useEffect(() => {
    if (isOpen) form.reset();
  }, [form, isOpen]);

  const handleSubmit = form.handleSubmit((data) => {
    onAddCommitment(data);
    disclosure.onClose();
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <FormProvider {...form}>
          <form onSubmit={handleSubmit}>
            <ModalHeader>Is this a sublimit?</ModalHeader>
            <ModalCloseButton />
            <ModalBody display="flex" flexDirection="column" gap="1rem">
              <RadioCardGroup<CommitmentFormData>
                name="isSublimit"
                required
                options={[
                  {
                    value: 'no',
                    content: (
                      <>
                        <Typography variant="base" fontWeight="bold">
                          No
                        </Typography>
                        <Typography variant="base-muted">
                          This amount applies directly to the overall facility
                          commitment.
                        </Typography>
                      </>
                    ),
                  },
                  {
                    value: 'yes',
                    content: (
                      <>
                        <Typography variant="base" fontWeight="bold">
                          Yes
                        </Typography>
                        <Typography variant="base-muted">
                          Indicates a capped portion of the facility that does
                          not add to the total commitment.
                        </Typography>
                      </>
                    ),
                  },
                ]}
              />
            </ModalBody>
            <ModalFooter>
              <Button
                variant="secondary"
                colorScheme="v2-aurora"
                mr={3}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button colorScheme="v2-aurora" type="submit">
                Add Commitment
              </Button>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  );
};
